<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Exceptional</h3>
        <v-btn flat icon color="primary" title="Load Report History" @click="viewRptHistory">
          <v-icon>mdi-archive</v-icon>
          <rpt-jobs-history title="Report History" id="travelExceptional" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field :label="labels.customName" v-model="reportForm.customName" data-vv-name="customName" :data-vv-as="labels.customName"></v-text-field>
              </v-flex>
              <v-flex xs12 md6></v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.reportForm.fromDate"></cal-picker>
              </v-flex>
              <v-flex lg6 xs12>
                <v-checkbox v-model="reportForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
              </v-flex>
              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import RptJobsHistory from '../../shared/RptJobsHistory'

export default {
  data() {
    return {
      labels: {
        customName: 'Report Name',
        fromDate: 'Entry Date From*',
        toDate: 'Entry Date To*',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?'
      },
      reportForm: {
        customName: undefined,
        fromDate: undefined,
        toDate: undefined,
        format: undefined,
        sendEmail: false
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      rptHistory: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      const result = 'required|from_to_date:' + this.reportForm.fromDate
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.travelExceptional
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'fromDate') {
            this.reportForm.fromDate = new Date(value)
          } else if (key === 'toDate') {
            this.reportForm.toDate = new Date(value)
          } else if (key === 'format') {
            this.reportForm.format = value
          } else if (key === 'sendEmail') {
            this.reportForm.sendEmail = value
          }
        })
      }
      this.rptHistory = false
    }
  },
  components: {
    RptJobsHistory
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
